// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__YHv0g","name":"Header_name__1IsDz","birthday":"Header_birthday__2oLsh","skeleton":"Header_skeleton__3bdAJ"};